exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#chat{height:80vw;text-align:left}.sin-M-B{margin-bottom:0}", ""]);

// exports
